var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.postingsOptions,
      loading: _vm.$apollo.queries.postings.loading,
      placeholder: "Select posting",
    },
    on: {
      search: (v) => (_vm.postingSearchString = v),
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }